import { SystemApi } from '@/apis/system.api';
import SwitchComponent from '@/components/common/form-component/switch-form-item/switch-component';
import showNotification from '@/components/common/notification';
import { TransactionConfigurationModel } from '@/models/system-config';
import { Button, Col, Divider, Form, Row, Spin } from 'antd';
import { height } from 'devexpress-reporting/scopes/reporting-designer-bands-metadata';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function TransactionManagement() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [logsForm] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await SystemApi.getTransactionConfig();
        logsForm.setFieldsValue({
          successLog: data.successLog,
          failureLog: data.failureLog,
          inProgressLog: data.inProgressLog,
        });
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  async function updateTransactionLog(values: any) {
    setLoadingBtn(true);
    try {
      const model: TransactionConfigurationModel = {
        successLog: values.successLog,
        failureLog: values.failureLog,
        inProgressLog: values.inProgressLog,
      };
      let data = await SystemApi.updateTransactionConfig(model);
      if (data) {
        showNotification('success', 'Update success');
      }
    } catch (error) {
    } finally {
      setLoadingBtn(false);
    }
  }

  function TitleTransactionConfiguration() {
    return (
      <>
        <Row gutter={16}>
          <Col
            sm={18}
            xs={14}
            lg={12}>
            <div className="head-form">
              <div className="h4-semiBold">Transaction Management</div>
              <div className="body-regular ">Transaction Management</div>
            </div>
          </Col>
          <Col
            sm={6}
            xs={10}
            lg={12}>
            <Form.Item className="btn-row">
              <Button
                loading={loadingBtn}
                className="btn-sumbit btn-base btn-main-base"
                htmlType="submit">
                {t('sysConfig.button.save')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Divider />
      </>
    );
  }

  function TransactionConfiguration() {
    const { t } = useTranslation();

    return (
      <>
        <Divider
          className="h5-semiBold"
          orientation="left"
          orientationMargin="0">
          Transaction Logs Configuration
        </Divider>
        <Row>
          <Col
            lg={8}
            sm={24}
            xs={24}>
            <SwitchComponent
              label="Success"
              name="successLog"
              valuePropName="checked"
            />
          </Col>
          <Col
            lg={8}
            sm={24}
            xs={24}>
            <SwitchComponent
              label="Failed"
              name="failureLog"
              valuePropName="checked"
            />
          </Col>
          <Col
            lg={8}
            sm={24}
            xs={24}>
            <SwitchComponent
              label="In Proccess"
              name="inProgressLog"
              valuePropName="checked"
            />
          </Col>
        </Row>
      </>
    );
  }

  return (
    <Spin
      tip="Loading"
      spinning={isLoading}>
      <Form
        className="application-container"
        style={ {minHeight: "300px" }}
        form={logsForm}
        onFinish={updateTransactionLog}
        layout="vertical"
        labelWrap>
        <TitleTransactionConfiguration />
        <TransactionConfiguration />
      </Form>
    </Spin>
  );
}
export default TransactionManagement;
